// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_RunRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_RunRow — one row of `scheduled_job_runs`.
 *
 * Used both by GET /scheduled-jobs/{id}/history (up to 50 rows, newest
 * first) and by POST /scheduled-jobs/run-now (a single-element `rows` — the
 * run that request just closed).
 *
 * `status` is 'running' | 'success' | 'failed' | 'dead' | 'skipped'. A
 * caller that only reads the envelope's `success` flag would miss a real
 * refusal here — POST /scheduled-jobs/run-now always answers HTTP
 * success:true once the request itself was accepted; the run's OWN outcome
 * lives in THIS row's `status` / `error_message`, read from inside the
 * envelope (services/app-frontend-service/src/composables/useGraceAdmin.ts:84-87
 * is the canonical example of this exact pattern in this codebase).
 *
 * Datetime fields are ISO-8601 UTC strings — the controller converts from
 * the GMT-3 storage format before building this row.
 */
import { registerContract } from './validate'

export interface ScheduledJobs_RunRow {
id: number
job_id: number
scheduled_for?: string
status?: string
attempts?: number
started_at?: string
finished_at?: string
error_message?: string
result_summary?: string
created_at?: string
}

registerContract('ScheduledJobs_RunRow', {
  id:             { type: 'number',  required: true },
  job_id:         { type: 'number',  required: true },
  scheduled_for:  { type: 'string',  required: false },
  status:         { type: 'string',  required: false },
  attempts:       { type: 'number',  required: false },
  started_at:     { type: 'string',  required: false },
  finished_at:    { type: 'string',  required: false },
  error_message:  { type: 'string',  required: false },
  result_summary: { type: 'string',  required: false },
  created_at:     { type: 'string',  required: false },
})
